"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isFunction = _interopRequireDefault(require("./isFunction"));

var _isNil = _interopRequireDefault(require("./isNil"));

var toJSON = function toJSON(obj) {
  if ((0, _isNil["default"])(obj) || !(0, _isFunction["default"])(obj.toJSON)) return obj;
  return obj.toJSON();
};

var _default = toJSON;
exports["default"] = _default;